export enum CommunicationsResponseGetCallLogPIIError {
  unableToGetCallLog = 'unableToGetCallLog',
  unableToGetCallerInfo = 'unableToGetCallerInfo',
}
